import WebSocketStore from 'core/classes/services/WebSocketStore'

class AuthApi {
  public async authByToken(token: string) {
    const wsClient = WebSocketStore.get('onboarding')

    const response = await wsClient.call({
      service: 'auth',
      action: 'token',
      payload: { token },
      returnError: true,
    })
    if (response.status === 'success') {
      /**
       * Copied from the legacy onboarding auth flow.
       * This is dirty hack. WebSocketClient have to be rewritten. It should not know anything about auth
       */
      // @ts-ignore
      wsClient.authSecured = true
    } else {
      throw new Error('Access is denied')
    }

    return true
  }
}

export const onboardingAuthApi = new AuthApi()
